import React from "react";
import {
  Box,
  Container,
  useMediaQuery,
  useTheme,
  Grid,
  Typography,
  List,
  ListItem,
} from "@mui/material";
import bigdataBgImg from "@/assets/imgs/companies/company_backgraound.png";

const OrganizationSummary: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
      <Box
          component={'div'}
          className={'home-item bigdata'}
          sx={{
            backgroundImage: `url(${bigdataBgImg})`,
            backgroundSize: 'cover',
          }}
      >
        <Container maxWidth="xl">
          <Box className={'text-right'}>
            <Box className={'t-48 bigdata-title'}>프람트테크놀로지는</Box>
            <Box className={'t-24 bigdata-desc'}>
              <Box>공공분야 SI전문기업으로서</Box>
              <Box>새로운 도전과 혁신으로 시장을 주도해 나갈 것입니다.</Box>
            </Box>
          </Box>
        </Container>
      </Box>
  );
};

export default OrganizationSummary;
